// extracted by mini-css-extract-plugin
module.exports = {"sortingArrow":"sortingMenuItem_sortingArrow__1Lqfw"};